import { Component, Prop, Vue, Watch } from "vue-property-decorator";
import { STYLE_CLASSES } from "@/shared/constants/StyleConstants";
import Vuetify from "vuetify";
import {
  EMIT_EVENTS,
  MODAL_MESSAGES,
  NOTIFICATION_TEMP_CONSTANTS,
  NOTIFICATION_TEMP_MESSAGES
} from "../../constants/NotificationTemplateConstants";
import { FORM_CONSTANTS } from "@/shared/constants/FormConstants";
import { ListOptions } from "../../models/list-options.model";
import Snackbar from "@/shared/components/Snackbar/Snackbar";

Vue.use(Vuetify);

@Component({
  name: "EditTemplateListsModal"
})
export default class EditTemplateListsModal extends Vue {
  @Prop() private dialog!: boolean;
  @Prop() private list!: ListOptions;

  ACCEPT_BTN = FORM_CONSTANTS.BUTTON.ACCEPT;
  CANCEL_BTN = FORM_CONSTANTS.BUTTON.CANCEL;
  cardClass = STYLE_CLASSES.CARD;
  itemToAdd = "";
  itemExists = false;
  localList: ListOptions = new ListOptions();
  listOfItemsToAdd: Array<string> = [];
  localOptions: Array<string> = [];
  modalTitle = "";
  NAME = NOTIFICATION_TEMP_CONSTANTS.NAME;
  primaryBtnClass = STYLE_CLASSES.PRIMARY_BTN;
  roundBtnClassTertiary = STYLE_CLASSES.TERTIARY_ROUND_BTN;
  secBtnClass = STYLE_CLASSES.SECONDARY_BTN;
  terBtnClass = STYLE_CLASSES.TERTIARY_BTN;
  textFieldClass = STYLE_CLASSES.TEXT_FIELD;

  @Watch("dialog")
  handleDialogChange() {
    this.localList = this.list;
    this.modalTitle = `${MODAL_MESSAGES.TITLE} ${this.localList.name}`;
    this.localOptions = this.dialog ? this.localList.options : [];
  }

  cancel() {
    this.resetData();
    this.$emit("modalCancel");
  }

  openListCrud() {
    this.$router.push(`/lists/${this.localList.id}`);
    this.resetData();
  }

  addNewItemToList() {
    if (this.itemAlreadyExists(this.itemToAdd)) {
      Snackbar.popError(
        NOTIFICATION_TEMP_MESSAGES.ITEM_NOT_EXISTS(this.itemToAdd)
      );
    } else {
      this.listOfItemsToAdd.push(this.itemToAdd);
      this.itemToAdd = "";
    }
  }

  saveList() {
    this.$emit(
      EMIT_EVENTS.MODAL_SAVE,
      this.listOfItemsToAdd,
      this.localList.id
    );
    this.resetData();
  }

  resetData() {
    this.localList = new ListOptions();
    this.localOptions = [];
    this.listOfItemsToAdd = [];
  }

  itemAlreadyExists(item: string) {
    return (
      this.localList.options.includes(item) ||
      this.listOfItemsToAdd.includes(item)
    );
  }

  deleteItem(index: number) {
    this.listOfItemsToAdd.splice(index);
  }
}
